import React, { useCallback, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { useGetPoliciesForSuggestions } from "apis/policy";

import FormAutoComplete from "components/FormAutoComplete/FormAutoComplete";
import Locale from "react-intl-universal";

const FormPolicySuggestions = ({ onSelectPolicy }) => {
  const [keyword, setKeyword] = useState();
  const { data: policies } = useGetPoliciesForSuggestions(keyword);

  const onKeywordChange = useCallback((newKeyword) => {
    setKeyword(newKeyword);
  }, []);

  const policySuggestions = useMemo(
    () =>
      policies && Array.isArray(policies)
        ? policies.map((policy) => ({
            key: policy._id,
            value: policy.name,
            label: policy.name,
          }))
        : [],
    [policies]
  );

  const handleOnSelectionChange = (selectedPolicyName, options) => {
    // Because form field always set back to id if I use id as value, will need to use key to store id and value to store building name
    const selectedPolicyId = options.key;
    const selectedPolicy = policies.find(
      (policy) => policy._id === selectedPolicyId
    );
    onSelectPolicy(selectedPolicy);
  };

  return (
    <FormAutoComplete
      name="name"
      label={Locale.get("addNewAdvisee.policySection.policyName")}
      requiredErrorMessage={Locale.get(
        "addNewAdvisee.policySection.errMsgPolicyName"
      )}
      placeholder={Locale.get(
        "addNewAdvisee.policySection.policyNamePlaceholder"
      )}
      selections={policySuggestions}
      onSearch={(key) => onKeywordChange(key)}
      onSelect={handleOnSelectionChange}
    />
  );
};

FormPolicySuggestions.propTypes = {
  defaultValue: PropTypes.any,
  onSelectPolicy: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
};

FormPolicySuggestions.defaultProps = {
  defaultValue: undefined,
  onInputChange: () => {},
};

export default FormPolicySuggestions;
